$(document).ready(function() {

    $(function() {
        
        console.log('***** SCRIPT 2021 zip zip ***');
      
            //  BASE URL
            var l = window.location;
            var baseurl = l.protocol + "//" + l.host + "/" + l.pathname.split('/')[1]+ "/";
            if (l.host=="localhost") {
                var baseurl = "http://kraak.test/";
             } else {
                var baseurl = "http://kraak.net/"
            }
            // ===============================================
            // MASONRY ====================================
            // ===============================================
            var $grid = $('.masonry').imagesLoaded( function() {
                // init Masonry after all images have loaded
                $grid.masonry({
                    // set itemSelector so .grid-sizer is not used in layout
                    itemSelector: '.masonry-item ',
                    // use element for option
                    columnWidth: '.masonry-sizer',
                    percentPosition: true
                });
              });

            var $gridFourColcol = $('.masonry-four-col').imagesLoaded( function() {
                // init Masonry after all images have loaded
                $gridFourColcol.masonry({
                    // set itemSelector so .grid-sizer is not used in layout
                    itemSelector: '.masonry-item ',
                    // use element for option
                    columnWidth: '.masonry-sizer',
                    percentPosition: true
                });
              });


            // ===============================================
            // NAVIGATION ====================================
            // ===============================================
            // NAV bar
            $('.m-menu').click(function(){
                $('html, body').toggleClass('noscroll');
                $('body').toggleClass('m-menu-open');
              });
            
            
           
            // ===============================================
            // HOMEPAGE ====================================
            // ===============================================

            $('.js-hide-modal').click(function(){
                $('.image-modal').hide();
             });

            


       
    
    });



});
